<template>
  <div class="mb-2">
    <div v-if="useDropdown" class="dropdown output-actions-menu">
      <d-button
        type="button"
        class="btn-dark btn-block dropdown-toggle"
        :disabled="!menuEnabled"
        aria-haspopup="true"
        :aria-expanded="open ? 'true' : 'false'"
        @click.prevent="toggleMenu"
      >
        {{ $t('shared.puzzle.outputMenu') }}
      </d-button>
      <div class="dropdown-menu" :class="{ show: open }">
        <button
          type="button"
          class="dropdown-item"
          :disabled="!canSend"
          @click="requestSend"
        >
          <i class="fas fa-paper-plane" />
          {{ $t('shared.puzzle.sendTitle') }}
        </button>
        <button
          type="button"
          class="dropdown-item"
          :disabled="!canExport"
          @click="requestExport"
        >
          <i class="fas fa-download" />
          {{ $t('shared.actions.export') }}
        </button>
      </div>
    </div>

    <d-button
      v-else
      type="button"
      class="btn-dark btn-block"
      :disabled="!canSend"
      @click.prevent="requestSend"
    >
      <i class="fas fa-paper-plane mr-1" />
      {{ $t('shared.puzzle.sendTitle') }}
    </d-button>

    <confirmation-modal
      v-if="!delegateSend"
      :cancel="closeSendModal"
      :confirm="confirmSend"
      :title="$t('shared.puzzle.sendTitle')"
      :message="sendModalMessage"
      :confirm-label="$t('shared.actions.send')"
      type-modal="send_current_puzzle_modal"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import PuzzleService from '_services/rest/modules/puzzle';
import ConfirmationModal from '_shared/ConfirmationModal.vue';

export default {
  name: 'output-actions-menu',
  components: {
    ConfirmationModal,
  },
  props: {
    canExport: {
      type: Boolean,
      default: false,
    },
    canSend: {
      type: Boolean,
      default: false,
    },
    showExport: {
      type: Boolean,
      default: true,
    },
    delegateSend: {
      type: Boolean,
      default: false,
    },
    puzzleId: {
      type: [Number, String],
      default: null,
    },
    successKey: {
      type: String,
      default: '',
    },
    errorKey: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      open: false,
    };
  },
  computed: {
    useDropdown() {
      return this.showExport;
    },
    menuEnabled() {
      return this.canExport || this.canSend;
    },
    sendModalMessage() {
      return this.$tc('shared.puzzle.sendConfirm', 1, { count: 1 });
    },
  },
  mounted() {
    document.addEventListener('click', this.onDocumentClick);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onDocumentClick);
  },
  methods: {
    ...mapActions(['setToggle', 'activeAlert']),
    onDocumentClick(event) {
      if (!this.$el.contains(event.target)) {
        this.open = false;
      }
    },
    toggleMenu() {
      if (!this.menuEnabled) return;
      this.open = !this.open;
    },
    requestExport() {
      if (!this.canExport) return;
      this.open = false;
      this.$emit('export');
    },
    requestSend() {
      if (!this.canSend) return;
      this.open = false;

      if (this.delegateSend) {
        this.$emit('send');
        return;
      }

      if (!this.puzzleId) return;

      this.setToggle({ type: 'send_current_puzzle_modal', bool: true });
    },
    closeSendModal() {
      this.setToggle({ type: 'send_current_puzzle_modal', bool: false });
    },
    confirmSend() {
      this.closeSendModal();

      PuzzleService.send([this.puzzleId])
        .then(() => {
          this.activeAlert({
            message: this.$t(this.successKey),
            theme: 'success',
          });
        })
        .catch(() => {
          this.activeAlert({
            message: this.$t(this.errorKey),
            theme: 'danger',
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.output-actions-menu {
  position: relative;

  .dropdown-menu {
    width: 100%;
    min-width: 100%;
  }

  .dropdown-item:disabled {
    color: #868e96;
    pointer-events: none;
    background-color: transparent;
  }
}
</style>
